var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKurdiaghoriz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "0 0 798 111.61",
    viewBox: "0 0 798.01 111.62",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m183.35 80.93-13.13-22.44-5.7 6.64v15.8h-9.6V30.42h9.6v21.29h.43l17.25-21.29h11.91l-17.32 20.35 17.75 30.16h-11.18Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.1 62.09V30.41h9.6v31.61c0 6.71 3.61 10.82 10.39 10.82s10.46-4.11 10.46-10.9V30.41h9.53v31.61c0 11.83-7.72 19.84-19.99 19.84s-19.99-7.94-19.99-19.77Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.91 30.42h18.91c10.32 0 17.39 6.57 17.39 16.09 0 7-4.11 12.34-9.45 14.72l11.11 19.7h-10.75l-9.45-18.04h-8.15v18.04h-9.6V30.42Zm18.18 24.25c4.76 0 8.3-2.81 8.3-8.15 0-4.55-3.1-7.87-8.44-7.87h-8.44v16.02h8.59Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8 30.42h15.01c16.02 0 25.33 10.54 25.33 25.26 0 15.66-9.31 25.26-25.33 25.26H318.8V30.42Zm15.01 45.32c11.98 0 19.34-7.36 19.34-20.06s-7.22-19.99-19.34-19.99h-9.16v40.05h9.16Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.52 30.42h5.84v50.51h-5.84V30.42Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 30.42h6.86l19.41 50.51h-6.13l-4.55-11.98H393.7l-4.55 11.98h-6.13l19.48-50.51Zm13.57 33.19-9.96-26.41h-.43l-9.96 26.41h20.35Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.38 55.67c0-14.86 10.97-26.19 25.98-26.19 11.62 0 20.42 6.86 23.74 16.38h-6.49c-2.67-6.57-8.73-10.9-17.25-10.9-11.91 0-19.92 8.88-19.92 20.71s8.15 20.71 20.06 20.71c10.32 0 18.4-6.78 18.76-16.89h-20.49v-5.12h27.06c.07 18.26-11.76 27.49-25.4 27.49-15.01 0-26.05-11.18-26.05-26.19Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.65 30.42h5.99l26.41 40.34h.43V30.42h5.77v50.51h-6.21l-26.12-40.34h-.43v40.34h-5.84V30.42Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.08 55.67c0-14.86 11.11-26.19 26.12-26.19s26.12 11.47 26.12 26.19-11.11 26.19-26.19 26.19-26.05-11.18-26.05-26.19Zm46.18 0c0-11.83-8.52-20.71-20.06-20.71s-20.06 8.88-20.06 20.71 8.51 20.71 20.06 20.71 20.06-8.73 20.06-20.71Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.18 65.92h5.84c0 5.84 4.76 10.54 12.41 10.54 6.64 0 11.4-3.25 11.4-8.51 0-15.8-27.93-4.76-27.93-24.97 0-7.22 5.99-13.49 16.16-13.49 7.65 0 16.6 4.19 16.6 14.65h-5.99c0-5.77-3.82-9.31-10.68-9.31s-10.25 3.97-10.25 8.15c0 13.78 28 4.19 28 24.61 0 7.94-6.49 14.29-17.53 14.29-10.03 0-18.04-6.57-18.04-15.95Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.97 35.76h-15.44v-5.34h36.73v5.34h-15.44v45.17h-5.84V35.76Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.64 30.42h5.84v50.51h-5.84V30.42Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.87 55.67c0-14.86 11.04-26.19 25.98-26.19 11.62 0 20.42 6.86 23.74 17.1h-6.28c-2.67-7.65-9.67-11.62-17.46-11.62-11.18 0-19.92 8.88-19.92 20.71s8.73 20.71 19.92 20.71c7.79 0 14.72-3.9 17.25-11.62h6.49c-3.17 10.46-12.19 17.1-23.81 17.1-14.94 0-25.9-11.18-25.9-26.19Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.44 65.92h5.84c0 5.84 4.76 10.54 12.41 10.54 6.64 0 11.4-3.25 11.4-8.51 0-15.8-27.93-4.76-27.93-24.97 0-7.22 5.99-13.49 16.16-13.49 7.65 0 16.6 4.19 16.6 14.65h-5.99c0-5.77-3.82-9.31-10.68-9.31S770 38.8 770 42.98c0 13.78 28 4.19 28 24.61 0 7.94-6.49 14.29-17.53 14.29-10.03 0-18.04-6.57-18.04-15.95Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.59 69.02c.46 10.91 3.46 21.6 8.42 31.3 1.63 3.23 3.46 6.36 5.47 9.38h-1.34c6-9.05 10.52-19.14 12.59-29.84.73-3.56 1.11-7.19 1.29-10.84.18 3.65-.05 7.33-.52 10.97-1.55 11.38-6.3 22.14-12.7 31.62-8.46-12.46-13.95-27.39-13.22-42.59Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1 69.02c.55 13.38-4.97 26.31-12.72 36.97l-.58.81-.58-.81C47.47 95.32 41.95 82.4 42.5 69.02h.16c.15 3.29.54 6.55 1.27 9.74.7 3.2 1.69 6.32 2.89 9.35 2.42 6.06 5.72 11.75 9.56 17.04h-1.16c5.75-7.92 10.34-16.79 12.45-26.39.73-3.19 1.12-6.46 1.27-9.74h.16Z",
    fill: "#ffffff",
    opacity: 0.89,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.16 69.02c.39 12.01-5.51 23.24-12.87 32.38l-.49.61-.49-.61c-7.36-9.13-13.26-20.37-12.87-32.38h.28c.21 5.85 1.74 11.58 4.2 16.87 2.46 5.29 5.7 10.18 9.37 14.72h-.97c5.46-6.8 10.15-14.42 12.3-22.94.74-2.82 1.15-5.73 1.26-8.66h.28Z",
    fill: "#ffffff",
    opacity: 0.78,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2 69.02c.23 10.68-6.1 20.14-13 27.78l-.4.44-.4-.44c-6.9-7.63-13.23-17.09-13-27.78h.36a28.6 28.6 0 0 0 1.29 7.58c1.49 4.93 4.15 9.42 7.2 13.54 1.54 2.06 3.21 4.03 4.95 5.93h-.79a75.46 75.46 0 0 0 4.95-5.93c3.05-4.12 5.71-8.61 7.2-13.54.76-2.45 1.2-5 1.28-7.58h.36Z",
    fill: "#ffffff",
    opacity: 0.67,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.93 69.2c.6-.34.17-.09.3-.17 0 .11-.01.31-.01.42-.17 9.22-6.8 16.67-13.1 22.74l-.31.29-.31-.29c-6.41-6.15-13.13-13.78-13.11-23.17h.4c.11 4.5 1.98 8.74 4.46 12.43 2.5 3.71 5.58 7.02 8.87 10.09h-.61c3.28-3.07 6.37-6.37 8.87-10.09 2.44-3.63 4.3-7.81 4.44-12.22v-.19c.13-.09-.3.16.3-.19l-.2.34Z",
    fill: "#ffffff",
    opacity: 0.56,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.93 69.2c.6-.34.17-.09.3-.17s0 .02 0 .02c0 .09-.01.26-.01.35-.3 7.67-7.61 13.73-13.18 18.19l-.22.17-.22-.17c-5.76-4.66-13-10.53-13.2-18.56h.4c.4 7.72 7.63 13.49 13.24 17.99h-.44c5.35-4.24 12.47-10.08 13.19-17.28.01-.19.04-.52.05-.71.13-.08-.3.17.3-.18l-.2.34Z",
    fill: "#ffffff",
    opacity: 0.44,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.94 69.18c.54-.31.15-.08.27-.15s0 .02 0 .02v.02c-.08 3.44-2.69 6.12-5.12 8.25-2.56 2.19-5.41 4-8.27 5.73-2.87-1.74-5.71-3.54-8.27-5.73-2.45-2.14-5.06-4.81-5.13-8.29h.36c.14 3.31 2.7 5.87 5.08 7.93 2.5 2.11 5.29 3.87 8.1 5.55h-.27c2.81-1.68 5.6-3.44 8.1-5.55 2.36-2.05 4.9-4.56 5.07-7.85v-.06c.12-.08-.27.15.27-.16l-.18.31Z",
    fill: "#ffffff",
    opacity: 0.33,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.96 69.14c.42-.24.12-.06.21-.12s0 .01 0 .01c-.06 1.47-1.15 2.61-2.21 3.5-3.32 2.61-7.3 4.17-11.14 5.82-3.84-1.64-7.82-3.21-11.14-5.82-1.07-.9-2.16-2.03-2.22-3.51h.28c.06 1.37 1.13 2.45 2.13 3.28 3.07 2.51 7.79 4.22 10.88 5.69 3.34-1.47 12.85-4.94 13.14-8.91v-.05c.09-.06-.21.11.21-.13l-.14.24Z",
    fill: "#ffffff",
    opacity: 0.22,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.99 69.09c.24-.14.07-.04.12-.06s0 .01 0 .01v.05c-.36 1.59-4.83 2.52-6.3 2.99-2.31.61-4.65 1.11-6.98 1.61-3.5-.76-7.02-1.47-10.41-2.65-.84-.32-1.7-.64-2.41-1.21-.23-.19-.46-.46-.47-.8h.16c.01.26.2.5.42.68.69.55 1.54.87 2.36 1.18 3.31 1.16 7.05 1.89 10.34 2.62 2.48-.64 12.32-2.26 13.14-4.39 0-.02.01-.07.01-.09l.12-.07-.08.14Z",
    fill: "#ffffff",
    opacity: 0.11,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.59 42.59c-10.91.46-21.6 3.46-31.3 8.42a90.628 90.628 0 0 0-9.38 5.47v-1.34c9.05 6 19.14 10.52 29.84 12.59 3.56.73 7.19 1.11 10.84 1.29-3.65.18-7.33-.05-10.97-.52C20.24 66.95 9.48 62.19 0 55.8c12.46-8.46 27.39-13.95 42.59-13.22Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.59 69.1c-13.38.55-26.31-4.97-36.97-12.72l-.81-.58.81-.58c10.67-7.75 23.59-13.27 36.97-12.72v.16c-3.29.15-6.55.54-9.74 1.27a59.5 59.5 0 0 0-9.35 2.89c-6.06 2.42-11.75 5.72-17.04 9.56v-1.16c7.92 5.75 16.79 10.34 26.39 12.45 3.19.73 6.46 1.12 9.74 1.27v.16Z",
    fill: "#ffffff",
    opacity: 0.89,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.59 69.16c-12.01.38-23.24-5.51-32.38-12.87l-.61-.49.61-.49c9.13-7.36 20.37-13.26 32.38-12.87v.28c-5.85.21-11.58 1.74-16.87 4.2-5.29 2.46-10.18 5.7-14.72 9.37v-.97c6.8 5.46 14.42 10.15 22.94 12.3 2.82.74 5.73 1.15 8.66 1.26v.28Z",
    fill: "#ffffff",
    opacity: 0.78,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.59 69.2c-10.68.23-20.14-6.1-27.78-13l-.44-.4.44-.4c7.63-6.9 17.09-13.23 27.78-13v.36a28.6 28.6 0 0 0-7.58 1.29c-4.93 1.49-9.42 4.15-13.54 7.2-2.06 1.54-4.03 3.21-5.93 4.95v-.79a75.46 75.46 0 0 0 5.93 4.95c4.12 3.05 8.61 5.71 13.54 7.2 2.45.76 5 1.2 7.58 1.28v.36Z",
    fill: "#ffffff",
    opacity: 0.67,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.42 68.93c.34.6.09.17.17.3-.11 0-.3-.01-.41-.01-9.22-.17-16.67-6.8-22.74-13.1l-.29-.31.29-.31c6.15-6.41 13.78-13.13 23.17-13.11v.4c-4.5.11-8.74 1.98-12.43 4.46-3.71 2.5-7.02 5.58-10.09 8.87v-.61c3.07 3.28 6.37 6.37 10.09 8.87 3.63 2.44 7.81 4.3 12.22 4.44h.19c.08.13-.17-.3.18.3l-.34-.2Z",
    fill: "#ffffff",
    opacity: 0.56,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.42 68.93c.34.6.09.17.17.3s-.01 0-.01 0c-.09 0-.26-.01-.35-.01-7.67-.3-13.73-7.61-18.19-13.18l-.17-.22.17-.22c4.66-5.76 10.53-13 18.56-13.2v.4c-7.72.4-13.49 7.63-17.99 13.24v-.44c4.24 5.35 10.08 12.47 17.28 13.19.19.01.52.04.71.05.08.13-.17-.3.18.3l-.34-.2Z",
    fill: "#ffffff",
    opacity: 0.44,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44 68.94c.31.54.08.15.15.27h-.02c-3.44-.08-6.12-2.69-8.25-5.12-2.19-2.56-4-5.41-5.73-8.27 1.73-2.87 3.54-5.71 5.73-8.27 2.14-2.45 4.81-5.06 8.29-5.13v.36c-3.31.14-5.87 2.7-7.93 5.08-2.11 2.5-3.87 5.29-5.55 8.1v-.27c1.68 2.81 3.44 5.6 5.55 8.1 2.05 2.36 4.56 4.9 7.85 5.07h.06c.07.12-.15-.27.16.27l-.31-.18Z",
    fill: "#ffffff",
    opacity: 0.33,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.47 68.96c.24.42.06.12.12.21-1.47-.06-2.61-1.15-3.5-2.21-2.6-3.32-4.17-7.3-5.82-11.14 1.64-3.84 3.21-7.82 5.82-11.14.9-1.07 2.03-2.16 3.51-2.22v.28c-1.37.05-2.45 1.13-3.28 2.13-2.51 3.07-4.22 7.79-5.69 10.88 1.47 3.34 4.94 12.85 8.91 13.14h.05c.06.09-.12-.21.12.21l-.24-.14Z",
    fill: "#ffffff",
    opacity: 0.22,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.52 68.99c.14.24.04.07.06.12h-.05c-1.59-.36-2.52-4.83-2.99-6.3-.61-2.31-1.12-4.65-1.61-6.98.76-3.5 1.47-7.02 2.65-10.41.32-.84.64-1.7 1.21-2.41.19-.23.46-.46.8-.47v.16c-.26.01-.5.2-.68.42-.55.69-.87 1.54-1.17 2.36-1.16 3.31-1.89 7.05-2.62 10.34.64 2.48 2.26 12.31 4.39 13.14.02 0 .07.01.09.01l.07.12-.14-.08Z",
    fill: "#ffffff",
    opacity: 0.11,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.02 42.59c-.46-10.91-3.46-21.6-8.42-31.3a90.628 90.628 0 0 0-5.47-9.38h1.34c-6 9.05-10.52 19.14-12.59 29.84-.73 3.56-1.11 7.19-1.29 10.84-.18-3.65.05-7.33.52-10.97C44.66 20.24 49.41 9.48 55.81 0c8.46 12.46 13.95 27.39 13.22 42.59Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.94 42.59c-.46-13.17-6.03-25.6-13.72-36.13h1.16c-3.84 5.29-7.14 10.97-9.56 17.04-1.2 3.03-2.19 6.16-2.89 9.35-.73 3.19-1.12 6.46-1.27 9.74h-.16c-.55-13.38 4.97-26.3 12.72-36.97l.58-.81.58.81c5.81 8.05 10.38 17.23 12.06 27.08.53 3.27.8 6.59.66 9.89h-.16Z",
    fill: "#ffffff",
    opacity: 0.89,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.88 42.59C68.5 30.78 62.6 20.01 55.31 11h.97c-3.66 4.54-6.9 9.43-9.36 14.72-2.46 5.29-3.99 11.02-4.2 16.87h-.28c-.39-12.01 5.51-23.24 12.87-32.38l.49-.61.49.61c5.55 6.91 10.18 14.81 12.06 23.55.6 2.9.91 5.87.81 8.83h-.28Z",
    fill: "#ffffff",
    opacity: 0.78,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.84 42.59c-.35-10.46-6.59-19.57-13.43-27.05h.79c-1.74 1.9-3.41 3.87-4.95 5.93-3.05 4.12-5.71 8.61-7.2 13.54-.76 2.45-1.2 5-1.28 7.58h-.36c-.23-10.68 6.1-20.14 13-27.78l.4-.44.4.44c5.23 5.8 9.96 12.37 12.04 20 .67 2.54 1.04 5.16.96 7.77h-.36Z",
    fill: "#ffffff",
    opacity: 0.67,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.12 42.76c-.6-.35-.17-.1-.3-.18 0-.05-.01-.15-.01-.2-.14-4.42-2.01-8.59-4.44-12.22-2.5-3.71-5.58-7.02-8.87-10.09h.61c-3.28 3.07-6.37 6.37-8.87 10.09-2.48 3.69-4.35 7.93-4.46 12.43h-.4c-.02-9.39 6.7-17.02 13.11-23.17l.31-.29c1.76 1.65 3.46 3.36 5.06 5.18 4.46 5.06 8.43 11.29 8.36 18.25s0 .02 0 .02c-.13-.07.3.18-.3-.17l.2.34Z",
    fill: "#ffffff",
    opacity: 0.56,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.12 42.76c-.6-.35-.17-.1-.3-.18 0-.09-.02-.26-.02-.35-.49-7.36-7.8-13.34-13.21-17.64h.44C50.42 29.1 43.2 34.86 42.79 42.58h-.4c.19-8.1 7.6-14.05 13.41-18.73 5.71 4.55 13.29 10.78 13.41 18.68v.04c-.13-.07.3.18-.3-.17l.2.34Z",
    fill: "#ffffff",
    opacity: 0.44,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 42.74c-.54-.31-.15-.09-.27-.16 0-.03-.01-.11-.01-.14-.2-3.26-2.73-5.74-5.06-7.78-2.5-2.11-5.29-3.87-8.1-5.55h.27c-4.59 2.88-12.84 7.53-13.17 13.48h-.36c.2-6.19 8.56-10.95 13.26-13.94l.14-.08.14.08c4.58 2.88 12.85 7.69 13.24 13.62 0 .08.02.23.02.31-.12-.07.27.16-.27-.15l.18.31Z",
    fill: "#ffffff",
    opacity: 0.33,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.09 42.71c-.42-.24-.12-.07-.21-.12-.01-.06-.02-.17-.03-.24-.53-3.87-9.75-7.25-13.12-8.73-3.1 1.47-7.81 3.17-10.88 5.69-1 .83-2.07 1.92-2.13 3.28h-.28c.05-1.49 1.15-2.62 2.22-3.51 3.32-2.6 7.3-4.17 11.14-5.82 2.59 1.07 5.17 2.18 7.64 3.53 1.81 1.02 3.7 2.12 4.98 3.8.37.5.66 1.1.71 1.73 0 .07.03.2.03.27-.09-.05.21.12-.21-.12l.14.24Z",
    fill: "#ffffff",
    opacity: 0.22,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.06 42.66-.12-.07v-.04c-.1-.56-.7-.84-1.15-1.11-1.59-.81-3.33-1.26-5.04-1.73-2.24-.6-4.79-1.12-6.92-1.6-3.48.76-7 1.46-10.37 2.63-.82.31-1.67.63-2.36 1.18-.22.18-.41.42-.42.68h-.16c.02-.35.25-.61.47-.8.71-.57 1.57-.89 2.41-1.21 3.39-1.18 6.91-1.88 10.41-2.65 2.34.5 4.67 1.01 6.98 1.61 1.43.45 6.09 1.43 6.31 3.04-.05-.03.12.07-.12-.06l.08.14Z",
    fill: "#ffffff",
    opacity: 0.11,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.02 69.02c10.91-.46 21.6-3.46 31.3-8.42 3.23-1.63 6.36-3.46 9.38-5.47v1.34c-9.05-6-19.14-10.52-29.84-12.59-3.56-.73-7.19-1.11-10.84-1.29 3.65-.18 7.33.05 10.97.52 11.38 1.55 22.14 6.31 31.62 12.7-12.46 8.46-27.39 13.95-42.59 13.22Z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.02 42.51c13.38-.55 26.31 4.97 36.97 12.72l.81.58-.81.58C95.32 64.14 82.4 69.66 69.02 69.11v-.16c3.29-.15 6.55-.54 9.74-1.27a59.5 59.5 0 0 0 9.35-2.89c6.06-2.42 11.75-5.72 17.04-9.56v1.16c-7.92-5.75-16.79-10.34-26.39-12.45-3.19-.73-6.46-1.12-9.74-1.27v-.16Z",
    fill: "#ffffff",
    opacity: 0.89,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.02 42.45c12.01-.39 23.24 5.51 32.38 12.87l.61.49-.61.49c-9.13 7.36-20.37 13.26-32.38 12.87v-.28c5.85-.21 11.58-1.74 16.87-4.2 5.29-2.46 10.18-5.7 14.72-9.37v.97c-6.8-5.46-14.42-10.14-22.94-12.3-2.82-.74-5.73-1.15-8.66-1.26v-.28Z",
    fill: "#ffffff",
    opacity: 0.78,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.02 42.41c10.68-.23 20.14 6.1 27.78 13l.44.4-.44.4c-7.63 6.9-17.09 13.23-27.78 13v-.36a28.6 28.6 0 0 0 7.58-1.29c4.93-1.49 9.42-4.15 13.54-7.2 2.06-1.54 4.03-3.21 5.93-4.95v.79a75.46 75.46 0 0 0-5.93-4.95c-4.12-3.05-8.61-5.71-13.54-7.2-2.45-.76-5-1.2-7.58-1.28v-.36Z",
    fill: "#ffffff",
    opacity: 0.67,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2 42.69c-.34-.6-.09-.17-.17-.3.11 0 .3.01.41.01 9.22.17 16.67 6.8 22.74 13.1l.29.31-.29.31c-6.15 6.41-13.78 13.13-23.17 13.11v-.4c4.5-.11 8.74-1.98 12.43-4.46 3.71-2.5 7.02-5.58 10.09-8.87v.61c-3.07-3.28-6.37-6.37-10.09-8.87-3.63-2.44-7.81-4.3-12.22-4.44h-.19c-.08-.13.17.3-.18-.3l.34.2Z",
    fill: "#ffffff",
    opacity: 0.56,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2 42.69c-.34-.6-.09-.17-.17-.3s.01 0 .01 0c.09 0 .26.01.35.01 7.67.3 13.73 7.61 18.19 13.18l.17.22-.17.22c-4.66 5.76-10.53 13-18.56 13.2v-.4c7.72-.4 13.49-7.63 17.99-13.24v.44c-4.24-5.35-10.08-12.47-17.28-13.19-.19-.01-.52-.04-.71-.05-.08-.13.17.3-.18-.3l.34.2Z",
    fill: "#ffffff",
    opacity: 0.44,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.18 42.68c-.31-.54-.08-.15-.15-.27h.02c3.44.08 6.12 2.69 8.25 5.12 2.19 2.56 4 5.41 5.73 8.27-1.73 2.87-3.54 5.71-5.73 8.27-2.14 2.45-4.81 5.06-8.29 5.13v-.36c3.31-.14 5.87-2.7 7.93-5.08 2.11-2.5 3.87-5.29 5.55-8.1v.27c-1.68-2.81-3.44-5.6-5.55-8.1-2.05-2.35-4.56-4.9-7.85-5.07h-.06c-.07-.12.15.27-.16-.27l.31.18Z",
    fill: "#ffffff",
    opacity: 0.33,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14 42.66c-.24-.42-.06-.12-.12-.21 1.47.06 2.61 1.15 3.5 2.21 2.6 3.32 4.17 7.3 5.82 11.14-1.64 3.84-3.21 7.82-5.82 11.14-.9 1.07-2.03 2.16-3.51 2.22v-.28c1.37-.06 2.45-1.13 3.28-2.13 2.51-3.07 4.22-7.79 5.69-10.88-1.47-3.34-4.94-12.85-8.91-13.14h-.05c-.05-.09.12.21-.12-.21l.24.14Z",
    fill: "#ffffff",
    opacity: 0.22,
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.09 42.63c-.14-.24-.04-.07-.06-.12h.05c1.59.36 2.52 4.83 2.99 6.3.61 2.31 1.12 4.65 1.61 6.99-.76 3.5-1.47 7.02-2.65 10.41-.32.84-.64 1.7-1.21 2.41-.19.23-.46.46-.8.47v-.16c.26-.01.5-.2.68-.42.55-.69.87-1.54 1.18-2.36 1.16-3.31 1.89-7.05 2.62-10.34-.64-2.48-2.26-12.32-4.39-13.14-.02 0-.07 0-.09-.01l-.07-.12.14.08Z",
    fill: "#ffffff",
    opacity: 0.11,
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKurdiaghoriz);
export default __webpack_public_path__ + "static/media/KUR DIAG HORIZ.902d44e4f16e9137893035058ab84975.svg";
export { ForwardRef as ReactComponent };